import { ArStatementSortFields } from '@payments/pages/ar-statements/services/ar-statements.service';
import { DashboardSortFields } from '@payments/pages/payment-dashboard/services/payment-dashboard.service';
import { PaymentPreferenceSortFields } from '@payments/pages/payment-preferences/services/payment-preferences.service';
import {
  SortFields as InvoiceSortFields,
  PaymentActivitySortFields,
} from '@usf/payment-types';

export type SortType =
  | ArStatementSortFields
  | DashboardSortFields
  | InvoiceSortFields
  | PaymentActivitySortFields
  | PaymentPreferenceSortFields;

export const SortFields = {
  ...ArStatementSortFields,
  ...DashboardSortFields,
  ...InvoiceSortFields,
  ...PaymentActivitySortFields,
  ...PaymentPreferenceSortFields,
};
